/**
 * Textes de /v60 : ceux de /v51-/v52 (openBroV51Copy.js), sauf ce qui parle du créneau.
 * En V60, on paie d'abord et on choisit son créneau d'appel juste après, sur la page de confirmation
 * (SuccessPage.jsx → POST /api/calls/book). Plus de compte à rebours ni de créneau à réserver avant de payer.
 */

import BASE from './openBroV51Copy';

const faqFr = BASE.fr.faq
  .filter(([question]) => question !== 'Pourquoi le créneau a une limite ?')
  .map(([question, answer]) => (question === 'Comment se passe l’appel ?'
    ? [question, 'Juste après le paiement, **tu choisis ton créneau** parmi ceux proposés. Gaut t’appelle au numéro indiqué au paiement. Vous faites le point sur ta situation et **tu repars avec tes priorités du mois.**']
    : question === 'Les résultats sont-ils garantis ?'
      // Aligné sur les CGU (« Nous ne garantissons aucun résultat »).
      ? [question, 'Non. **Tu as un plan, un regard extérieur et un cadre.** Le travail, c’est toi qui le fais.']
      : [question, answer]));

const faqEn = BASE.en.faq
  .filter(([question]) => question !== 'Why does the slot have a deadline?')
  .map(([question, answer]) => (question === 'How does the call work?'
    ? [question, 'Right after you pay, **you pick your slot** from the ones offered. Gaut calls you on the number you give at checkout. You go over your situation and **you leave with your priorities for the month.**']
    : question === 'Are results guaranteed?'
      ? [question, 'No. **You get a plan, an outside view and structure.** The work is yours to do.']
      : [question, answer]));

const COPY = {
  fr: {
    ...BASE.fr,
    // Le premier toast parlait du créneau choisi : on garde l'offre et le contenu.
    toasts: BASE.fr.toasts.slice(1),
    bookLater: 'Tu choisis ton créneau d’appel juste après le paiement.',
    call: (minutes) => [
      `Tu paies, puis **tu choisis ton créneau juste après**, sur la page de confirmation. Gaut t’appelle au numéro indiqué${minutes ? ` : **${minutes} min en tête-à-tête.**` : '.'}`,
      'Pas un cours enregistré. **Une conversation sur ta situation**, et tu repars avec tes priorités du mois.',
    ],
    faq: faqFr,
    // Promotion (euros seulement) : 99 € barré. Avec une date de fin (offer.launchEndsAt) : la date et le compte à rebours ;
    // sans date (promotion sans fin depuis le 28/10/2026) : ni l'une ni l'autre.
    // L'abonnement Stripe garde le prix payé au départ, donc « bloqué » tant que la personne reste membre.
    launchPill: (pct) => `Promotion −${pct}`,
    launchLine: ({ price, was, end, left }) => (end
      ? `**${price}/mois au lieu de ${was}**, jusqu’au ${end}. Encore **${left}**. Ton prix reste bloqué tant que tu restes membre.`
      : `**${price}/mois au lieu de ${was}.** Ton prix reste bloqué tant que tu restes membre.`),
    cta: () => 'Commencer maintenant',
    ctaDeal: () => 'Commencer maintenant',
    barLaunch: (left) => `Fin dans ${left}`,
    launchFaq: ({ price, was, end }) => ['Pourquoi ce prix ?', end
      ? `C’est une **promotion** : **${price} par mois au lieu de ${was}**, jusqu’au ${end}. Ensuite, le prix passe à ${was}. Si tu rejoins avant, **tu gardes ${price} par mois** tant que tu restes abonné.`
      : `C’est une **promotion** : **${price} par mois au lieu de ${was}**. Si tu rejoins maintenant, **tu gardes ${price} par mois** tant que tu restes abonné.`],
    finalTitle: 'Ton plan **commence aujourd’hui.**',
    finalPill: 'Accès immédiat',
    // Bloc du bas : le plan alimentaire seul (page /eat). Mêmes contenus que /eat.
    eatPlan: {
      pill: 'Juste la nutrition',
      title: 'Tu veux seulement **le plan alimentaire ?**',
      text: 'Les recettes de Gaut, **le meal plan de la semaine**, la liste de courses chaque lundi et un plan sur 30 jours.',
      perMonth: '/ mois · résiliable à tout moment',
      cta: 'Voir le plan alimentaire',
    },
  },
  en: {
    ...BASE.en,
    toasts: BASE.en.toasts.slice(1),
    bookLater: 'You pick your call time right after you pay.',
    call: (minutes) => [
      `You pay, then **you pick your slot right after**, on the confirmation page. Gaut calls you on the number you give${minutes ? `: **${minutes} min, one to one.**` : '.'}`,
      'Not a recorded class. **A conversation about your situation**, and you leave with your priorities for the month.',
    ],
    faq: faqEn,
    launchPill: (pct) => `Sale −${pct}`,
    launchLine: ({ price, was, end, left }) => (end
      ? `**${price}/month instead of ${was}**, until ${end}. **${left}** left. Your price stays locked while you stay a member.`
      : `**${price}/month instead of ${was}.** Your price stays locked while you stay a member.`),
    cta: () => 'Start Now',
    ctaDeal: () => 'Start Now',
    barLaunch: (left) => `Ends in ${left}`,
    launchFaq: ({ price, was, end }) => ['Why this price?', end
      ? `It’s a **sale**: **${price} a month instead of ${was}**, until ${end}. After that, the price goes to ${was}. Join before and **you keep ${price} a month** as long as you stay subscribed.`
      : `It’s a **sale**: **${price} a month instead of ${was}**. Join now and **you keep ${price} a month** as long as you stay subscribed.`],
    finalTitle: 'Your plan **starts today.**',
    finalPill: 'Instant access',
    eatPlan: {
      pill: 'Just the food',
      title: 'Just want **the meal plan?**',
      text: 'Gaut’s recipes, **the weekly meal plan**, a shopping list every Monday and a 30-day plan.',
      perMonth: '/ month · cancel anytime',
      cta: 'See the meal plan',
    },
  },
};

export default COPY;
